<template>
    <div id="vehicle_reg_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title">Rates</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddRate" class="btn btn-primary pull-right" v-bind:to="{name: 'RatesCreate'}" > <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <strong id="errorMsg" class="field-error"></strong>
                        </div>
                    </div>
                    <div class="admin-page-content rate-list">
                        <data-table-filter-config :moduleName="'rateList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'rateList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listRates"
                                    mode="remote"
                                    title="Rates"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: deleteBtnAccess,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <a v-if="canViewLog" title="View Log" v-on:click.prevent="goToGetLogInfo(props.row.id)" class="fp-log-file-format" href="javascript:void(0)"></a>
                                                <router-link title="Edit Rate" v-if="canUpdateRate" class="fp-edit" v-bind:to="{name: 'RatesEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else :class="{ 'vgt-right-align': props.column.field === 'labor_rate' || props.column.field === 'travel_rate'}">
                                                {{ props.formattedRow[props.column.field] }}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="deleteBtnAccess" id="deleteRateBtn" v-on:click.prevent="rateDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                  <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);
import EventBus from "../event-bus";
import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
import AuditLogPopUp from "../AuditLogPopUp.vue";
Vue.component("audit-log-popup",AuditLogPopUp);

Vue.use(VueGoodTable);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

    export default {
        name: "RatesList",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            clearCacheData: () => import('@/components/ClearCacheData'),
            appFooter: () => import('@/components/Footer'),
        },
        mixins:[commonMixins,dataTableMixins],
        metaInfo() {
            return {title: "Rates | " + process.env.COPYRIGHT_NAME}
        },
        data: () => ({
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Warranty Dealer Name',
                    field: 'warranty_dealer_name',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Warranty Dealer Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Labor Rate',
                    field: 'labor_rate',
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Labor Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Labor Rate Effective Date',
                    field: 'labor_effective_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Labor Rate Effective Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Travel Rate',
                    field: 'travel_rate',
                    fpFieldType:"integer",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Travel Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Travel Rate Effective Date',
                    field: 'travel_effective_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Travel Rate Effective Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated By',
                    field: 'updated_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created At", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Updated At',
                    field: 'updated_at',
                    filterable: false,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated At", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            deleteBtnAccess: false,
            loading:false,
            canUpdateRate:false,
            canAddRate:false,
            canViewLog:false,
            pageKey:"_rates_list_",
            errorMsg: "",
            logs: [],
            popUpTitle: "Rate Activity Log Details",

        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'ev_list_rate') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'ev_add_rate') {
                            self.canAddRate = true;
                        }
                        if (permissions[i].name == 'ev_edit_rate') {
                            self.canUpdateRate = true;
                        }
                        if (permissions[i].name == 'ev_delete_rate') {
                            self.deleteBtnAccess = true;
                        }
                        if (permissions[i].name == 'ev_view_log_rate') {
                            self.canViewLog = true;
                        }
                    }
                }

            }
        },
        mounted: function() {
            var self = this;
            self.getPermissions();
        },
        methods: {
            cancelAll: function () {
              this.$refs.listRates.unselectAllInternal();
            },

            selectionChanged(param) {
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                $.ajax({
                    url: process.env.ROOT_API + "/rate/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                });
            },
            rateDelete(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Rate?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var data = this.$refs['listRates'].selectedRows;
                        var use = [];
                        for (var i = 0; i < data.length; i++) {
                            use.push(this.$refs['listRates'].selectedRows[i].id)
                        }
                        self.loading = true;
                        $("#deleteRateBtn").val("Deleting ...");
                        $.ajax({
                          url: process.env.ROOT_API + "/rate/delete",
                          type: "POST",
                          data: 'ids=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                            console.log("data==>",data);
                              self.loading = false;
                              setTimeout(function () {
                                  $("#deleteRateBtn").val("Delete");
                              }, 1000);
                              if (data.code == '200') {
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 5000);
                            }
                          }
                      });
                    }
                });
            },
            goToGetLogInfo(logId){
                var self = this;
                var logFlag = 'RATE_AUDIT';

                self.getLogInfo(logId, logFlag);
            },
        }
    };
</script>

<style scoped>
.data-table table.vgt-table .fp-log-file-format {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/rate/RatesList.vue